var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEmptyCarton = function SvgEmptyCarton(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 123,
    viewBox: "0 0 119 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.11 45.3338C106.222 45.3338 107.934 43.6199 107.934 41.5057C107.934 39.3916 106.222 37.6777 104.11 37.6777C101.997 37.6777 100.285 39.3916 100.285 41.5057C100.285 43.6199 101.997 45.3338 104.11 45.3338Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51618 66.0349C3.90582 66.0349 5.03235 64.9074 5.03235 63.5165C5.03235 62.1256 3.90582 60.998 2.51618 60.998C1.12653 60.998 0 62.1256 0 63.5165C0 64.9074 1.12653 66.0349 2.51618 66.0349Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0826 111.312C15.4722 111.312 16.5988 110.185 16.5988 108.794C16.5988 107.403 15.4722 106.275 14.0826 106.275C12.6929 106.275 11.5664 107.403 11.5664 108.794C11.5664 110.185 12.6929 111.312 14.0826 111.312Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5322 111.312L62.8412 100.248V54.8867L27.5322 65.8654V111.312Z",
    fill: "#B7BFCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M98.1503 111.312L62.8413 100.248V54.8867L98.1503 65.8654V111.312Z",
    fill: "#6D7C9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5322 111.312L62.8412 100.248V54.8867L27.5322 65.8654V111.312Z",
    fill: "url(#paint0_linear_38356_44425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1502 111.312L62.8412 100.248V54.8867L98.1502 65.8654V111.312Z",
    fill: "url(#paint1_linear_38356_44425)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8412 122.461L27.5322 111.397V66.0352L62.8412 77.099V122.461Z",
    fill: "#EDF1F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8413 122.461L98.1503 111.397V66.0352L62.8413 77.099V122.461Z",
    fill: "#DAE1ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M54.8412 114.461L27.5322 111.397V66.0352L62.8412 77.099L54.8412 114.461Z",
    fill: "url(#paint2_linear_38356_44425)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.8413 106.461L98.1503 111.397V66.0352L62.8413 77.099L70.8413 106.461Z",
    fill: "url(#paint3_linear_38356_44425)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8413 54.8865L46.2402 42.4609L10.3413 54.546L27.5323 65.8652L62.8413 54.8865Z",
    fill: "#DAE1ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8413 54.8865L79.4424 42.4609L115.341 54.546L98.1503 65.8652L62.8413 54.8865Z",
    fill: "#DAE1ED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5323 66.0352L62.8413 77.099L45.229 88.333L10.3413 76.7586L27.5323 66.0352Z",
    fill: "#EFF4FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1503 66.0352L62.8413 77.099L80.4537 88.333L115.341 76.7586L98.1503 66.0352Z",
    fill: "#EDF1F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6928 11.3375C77.6394 24.7619 79.1138 27.7447 79.5977 40.9727C79.4116 43.9921 79.2962 47.2755 77.8727 49.9194C75.9715 53.9638 71.3215 56.7648 66.9282 56.8102C62.4022 56.8911 57.9651 54.1199 55.968 49.8468C54.5629 47.2535 54.6076 43.7062 56.535 41.3517C58.6303 39.0935 62.3165 38.5305 64.9682 39.9415C67.8851 41.2814 69.6261 44.0676 70.271 47.0059C70.9158 49.9443 70.6325 53.1312 69.8454 56.0289C68.1991 63.0763 66.8356 63.4173 62.7983 75.349",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7132 4.233C78.7017 6.20698 76.8648 7.41567 74.5352 6.78538C72.0825 6.36727 70.3465 5.93635 70.2348 4.17455C70.291 2.36775 72.2623 1.6606 74.5697 0.863455C77.3363 -0.235865 78.5567 2.30402 78.7132 4.233Z",
    fill: "#DAE2EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8639 10.2679C64.107 11.5475 66.7277 11.9207 68.0048 9.96606C69.4051 7.79928 70.6038 6.22404 69.316 4.77723C68.0729 3.49759 66.8632 4.35911 64.0966 5.45843C61.8789 6.58994 61.4081 8.86609 62.8639 10.2679Z",
    fill: "#DAE2EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5996 2.10282C69.7309 1.62066 71.086 1.97439 71.6907 2.88748C71.9483 3.17684 72.2506 3.63339 72.3402 3.96775C73.303 6.21828 73.0003 8.44943 71.701 8.97659C70.2785 9.71593 68.3187 8.4491 67.5686 6.32076C67.3895 5.65203 67.2999 5.31767 67.1656 4.81613C67.0202 3.60087 67.4683 2.58498 68.5996 2.10282C68.5996 2.10282 68.7676 2.05782 68.5996 2.10282Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5986 38.3307H14.4085V36.1406H12.5314V38.3307H10.3413V40.2704H12.5314V42.4605H14.4085V40.2704H16.5986V38.3307Z",
    fill: "url(#paint4_linear_38356_44425)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4096 93.2779H19.2196V91.0879H17.3424V93.2779H15.1523V95.2177H17.3424V97.4077H19.2196V95.2177H21.4096V93.2779Z",
    fill: "url(#paint5_linear_38356_44425)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.147 93.4023L114.468 92.0494L115.821 89.3699L113.524 88.2103L112.171 90.8898L109.491 89.537L108.293 91.9103L110.973 93.2632L109.62 95.9427L111.917 97.1023L113.269 94.4228L115.949 95.7756L117.147 93.4023Z",
    fill: "url(#paint6_linear_38356_44425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38356_44425",
    x1: 51.695,
    y1: 58.172,
    x2: 46.8789,
    y2: 78.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38356_44425",
    x1: 51.695,
    y1: 58.172,
    x2: 46.8789,
    y2: 78.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38356_44425",
    x1: 35.4483,
    y1: 97.0804,
    x2: 43.9309,
    y2: 73.1223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38356_44425",
    x1: 81.8971,
    y1: 103.625,
    x2: 82.5642,
    y2: 73.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38356_44425",
    x1: 13.4704,
    y1: 36.3602,
    x2: 13.4704,
    y2: 39.9074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38356_44425",
    x1: 18.2815,
    y1: 91.3074,
    x2: 18.2815,
    y2: 94.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_38356_44425",
    x1: 114.537,
    y1: 89.059,
    x2: 112.346,
    y2: 93.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyCarton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty_carton.cdad6453.svg";
export { ForwardRef as ReactComponent };